import { Component } from "react";
import PropTypes from "prop-types";

class CustomLoader extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        className={`${this.props.isLoading ? "" : "hidden"} absolute custom-loading-bar-container`}
      >
        <div className="custom-loading-bar" style={{ width: `${100}%` }} />
      </div>
    );
  }
}
CustomLoader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};
export default CustomLoader;
